/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CreateResourceResponse
 */
export interface CreateResourceResponse {
	/**
	 * RID of the created resource
	 * @type {string}
	 * @memberof CreateResourceResponse
	 */
	rID: string;
	/**
	 * State information of the created resource
	 * @type {object}
	 * @memberof CreateResourceResponse
	 */
	state: object;
}

/**
 * Check if a given object implements the CreateResourceResponse interface.
 */
export function instanceOfCreateResourceResponse(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'rID' in value;
	isInstance = isInstance && 'state' in value;

	return isInstance;
}

export function CreateResourceResponseFromJSON(json: any): CreateResourceResponse {
	return CreateResourceResponseFromJSONTyped(json, false);
}

export function CreateResourceResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CreateResourceResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		rID: json['RID'],
		state: json['state'],
	};
}

export function CreateResourceResponseToJSON(value?: CreateResourceResponse | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		RID: value.rID,
		state: value.state,
	};
}
